<div class="group-forms-container">
  <!-- Unified Tool Header -->
  <div class="unified-tool-header">
    <div class="header-content">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" class="tool-icon">
          <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V15H17V17M17,13H7V11H17V13M17,9H7V7H17V9Z" />
        </svg>
      </div>
      <div class="header-text">
        <h1>Group Forms</h1>
        <p>Link parent and child forms to create grouped form relationships</p>
      </div>
    </div>
  </div>

  <!-- Tool Content -->
  <div class="tool-content">
    <!-- Event Selection Section -->
    <div class="event-selection-section" *ngIf="!groupForm.selectedEvent">
      <button *ngIf="embedded" type="button" class="tw-mb-4 tw-text-sm tw-font-medium tw-text-blue-700" (click)="backToEventSelection()">Back to events</button>
      <!-- Search Section -->
      <div class="search-section" *ngIf="!embedded">
        <div class="search-container">
          <svg viewBox="0 0 24 24" class="search-icon">
            <path
              d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
            />
          </svg>
          <input type="text" [formControl]="common.searchControl" (ngModelChange)="searchEvents($event)" placeholder="Search events..." class="search-input" />
          <div class="search-actions" *ngIf="common.searchControl.value?.trim()">
            <button class="clear-btn" (click)="clearSearch()" title="Clear search">
              <svg viewBox="0 0 24 24">
                <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Loading Section -->
      <div *ngIf="eventsConfig.loading" class="loading-section">
        <div class="loading-spinner"></div>
        <p>Loading events...</p>
      </div>

      <!-- Error Section -->
      <div *ngIf="eventsConfig.error && !eventsConfig.loading" class="error-section">
        <div class="error-content">
          <svg viewBox="0 0 24 24" class="error-icon">
            <path
              d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
            />
          </svg>
          <div class="error-text">
            <h3>Error Loading Events</h3>
            <p>{{ eventsConfig.error }}</p>
          </div>
        </div>
      </div>

      <!-- Events Grid -->
      <div *ngIf="!eventsConfig.loading && !eventsConfig.error && eventsConfig.events.length > 0" class="events-grid">
        <ngx-admin-event-card
          *ngFor="let event of eventsConfig.events"
          [event]="event"
          [isSelected]="false"
          [context]="'group-forms'"
          (editGroupForm)="updateEvent($event)"
          (editSpecificRelationship)="editSpecificRelationship($event)"
          (createNewRelationship)="viewEventDetails($event)"
        >
        </ngx-admin-event-card>
      </div>

      <!-- Empty State -->
      <div *ngIf="!eventsConfig.loading && !eventsConfig.error && eventsConfig.events.length === 0" class="empty-state">
        <h3>No Events Available</h3>
        <p>There are no events in your workspace yet.</p>
      </div>
    </div>

    <!-- Direct Form Editing Interface -->
    <div
      class="form-editing-section"
      *ngIf="groupForm.selectedEvent && (groupForm.selectedParent || groupForm.selectedChild || (!groupForm.showGroupForms && groupForm.selectedEvent))"
    >
      <!-- Back Button -->
      <div class="editing-header" *ngIf="groupForm.selectedEvent">
        <button class="back-btn" (click)="backToEventSelection()">
          <svg viewBox="0 0 24 24">
            <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
          </svg>
          Back to Events
        </button>
        <div class="editing-title">
          <h2 style="color: white">{{ isUpdating ? 'Edit' : 'Create' }} Group Form</h2>
          <p style="color: white">Event: {{ groupForm.selectedEvent.name }}</p>
        </div>
      </div>

      <!-- Form Selection -->
      <div class="form-selection-section">
        <h3>Link Parent and Child Forms</h3>
        <p>Select which forms should be linked as parent and child relationships</p>

        <div class="form-grid">
          <div class="form-field">
            <label for="parentPersona">Parent Form</label>
            <select [disabled]="isUpdating" id="parentPersona" [(ngModel)]="groupForm.selectedParent" (change)="onParentChange()" class="form-select">
              <option value="">-- Select parent form --</option>
              <ng-container *ngFor="let persona of groupForm.parentPersonas">
                <ng-container *ngIf="persona.type === 10 || isUpdating">
                  <option *ngIf="persona.id !== groupForm.selectedChild" [value]="persona.slug">
                    {{ persona.name }}
                  </option>
                </ng-container>
              </ng-container>
            </select>
          </div>

          <div class="form-field">
            <label for="childPersona">Child Form</label>
            <select [disabled]="isUpdating" id="childPersona" [(ngModel)]="groupForm.selectedChild" (change)="onChildChange()" class="form-select">
              <option value="">-- Select child form --</option>
              <ng-container *ngFor="let persona of groupForm.childPersonas">
                <ng-container *ngIf="persona.type === 10 || isUpdating">
                  <option *ngIf="persona.id !== groupForm.selectedParent" [value]="persona.slug">
                    {{ persona.name }}
                  </option>
                </ng-container>
              </ng-container>
            </select>
          </div>
        </div>

        <!-- Configuration Fields -->
        <div class="config-section" *ngIf="groupForm.selectedParent && groupForm.selectedChild">
          <h3>Configuration</h3>

          <div class="config-grid">
            <div class="config-field">
              <label for="titlesMain">Main Title</label>
              <input type="text" id="titlesMain" [(ngModel)]="groupForm.titlesMain" placeholder="Enter main title" class="form-input" />
            </div>

            <div class="config-field">
              <label for="addLabel">Add Label</label>
              <input type="text" id="addLabel" [(ngModel)]="groupForm.addLabel" placeholder="Enter add label" class="form-input" />
            </div>

            <div class="config-field">
              <label for="maximumEntries">Maximum Entries</label>
              <input type="number" id="maximumEntries" [(ngModel)]="groupForm.maximumEntries" placeholder="Enter maximum entries" min="1" class="form-input" />
            </div>
            <div class="config-field">
              <span class="section-title">Communication Settings</span>
              <div class="tw-flex !tw-flex-row tw-gap-2 tw-flex-wrap tw-items-center tw-h-full">
                <label class="tw-flex tw-content-center tw-flex-wrap tw-gap-2 !tw-text-sm !tw-font-medium !tw-text-gray-700" for="allowImport">
                  Show import button
                  <span>
                    <label class="tw-relative tw-inline-flex tw-cursor-pointer">
                      <input id="allowImport" type="checkbox" [(ngModel)]="groupForm.allowImport" class="tw-sr-only tw-peer" />
                      <div
                        class="tw-w-11 tw-h-6 tw-bg-gray-200 tw-rounded-full tw-peer peer-focus:tw-ring-4 peer-focus:tw-ring-blue-300 peer-checked:after:tw-translate-x-full peer-checked:after:tw-border-white after:tw-content-[''] after:tw-absolute after:tw-top-0.5 after:tw-start-[2px] after:tw-bg-white after:tw-border-gray-300 after:tw-border after:tw-rounded-full after:tw-h-5 after:tw-w-5 after:tw-transition-all peer-checked:tw-bg-blue-600"
                      ></div>
                    </label>
                  </span>
                </label>
                <label class="tw-flex tw-content-center tw-flex-wrap tw-gap-2 !tw-text-sm !tw-font-medium !tw-text-gray-700" for="allowInvitation">
                  Show invite button
                  <span>
                    <label class="tw-relative tw-inline-flex tw-cursor-pointer">
                      <input id="allowInvitation" type="checkbox" [(ngModel)]="groupForm.allowInvitation" class="tw-sr-only tw-peer" />
                      <div
                        class="tw-w-11 tw-h-6 tw-bg-gray-200 tw-rounded-full tw-peer peer-focus:tw-ring-4 peer-focus:tw-ring-blue-300 peer-checked:after:tw-translate-x-full peer-checked:after:tw-border-white after:tw-content-[''] after:tw-absolute after:tw-top-0.5 after:tw-start-[2px] after:tw-bg-white after:tw-border-gray-300 after:tw-border after:tw-rounded-full after:tw-h-5 after:tw-w-5 after:tw-transition-all peer-checked:tw-bg-blue-600"
                      ></div>
                    </label>
                  </span>
                </label>
              </div>
            </div>
          </div>

          <!-- Translations Section -->
          <div class="translations-section" *ngIf="common.availableLanguages.length > 0">
            <div class="translations-header">
              <h4>Translations</h4>
              <button type="button" (click)="addNewTranslation()" class="add-translation-btn">
                <svg viewBox="0 0 24 24">
                  <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                </svg>
                Add Translation
              </button>
            </div>

            <div class="translation-list" *ngIf="groupForm.groupFormTranslations.length > 0">
              <div class="translation-item" *ngFor="let translation of groupForm.groupFormTranslations; let i = index; trackBy: trackByTranslation">
                <div class="translation-header">
                  <div class="language-selector">
                    <label>Language</label>
                    <select [(ngModel)]="translation.slug" class="form-select">
                      <option value="">-- Select language --</option>
                      <option *ngFor="let lang of common.availableLanguages" [value]="lang.slug">{{ lang.name }} ({{ lang.slug }})</option>
                    </select>
                  </div>
                  <button type="button" (click)="removeTranslation(i)" class="remove-translation-btn">
                    <svg viewBox="0 0 24 24">
                      <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                    </svg>
                  </button>
                </div>

                <div class="translation-fields" *ngIf="translation.slug">
                  <div class="translation-field">
                    <label>Main Title ({{ translation.slug }})</label>
                    <input type="text" [(ngModel)]="translation.titlesMain" placeholder="Enter main title" class="form-input" />
                  </div>
                  <div class="translation-field">
                    <label>Add Label ({{ translation.slug }})</label>
                    <input type="text" [(ngModel)]="translation.titlesAddlabels" placeholder="Enter add label" class="form-input" />
                  </div>
                </div>
              </div>
            </div>

            <div class="no-translations" *ngIf="groupForm.groupFormTranslations.length === 0">
              <p>No translations added yet. Click "Add Translation" to add translations for different languages.</p>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="form-actions">
            <button type="button" (click)="cancelGroupForm()" class="cancel-btn">Cancel</button>
            <button type="button" (click)="submitGroupForm()" [disabled]="!groupForm.selectedEvent || !groupForm.selectedParent || !groupForm.selectedChild" class="submit-btn">
              {{ isUpdating ? 'Update' : 'Create' }} Group Form
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Close tool-content -->
</div>
